<button
    class="x-btn-primary go-to-profiling"
    translate="trends.button.view_historical_data"
    *ngIf="show"
    (click)="goToProfiling()"
></button>
